var Stamp = require('./stamp');


module.exports = Stamp.extend({


    getImgSrc: function() {
        return this.get('src');
    },

    getWidth: function() {
        return this.get('imageHeader').width;
    },

    getHeight: function() {
        return this.get('imageHeader').length;
    }


});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/user/stamps/graphicStamp.js
 ** module id = 94
 ** module chunks = 0
 **/